/* Shows/hides collection-discount badges ([data-sl-dw]) inside their
   scheduled window. Dates are UK wall-clock (Europe/London) so they match
   the automatic discount configured in Shopify Admin; Intl resolves GMT vs
   BST, keeping daylight saving correct. Same approach as c-countdown-banner.
   The script tag is emitted per badge but this guard runs the logic once. */
(function () {
  if (window.__slDiscountWindow) return;
  window.__slDiscountWindow = true;

  var TZ = 'Europe/London';

  /* Offset (ms) between UTC and the TZ wall clock at a given instant. */
  function tzOffsetAt(date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(date).reduce(function (acc, p) { acc[p.type] = p.value; return acc; }, {});
    var asUTC = Date.UTC(+parts.year, parts.month - 1, +parts.day,
      parts.hour === '24' ? 0 : +parts.hour, +parts.minute, +parts.second);
    return asUTC - date.getTime();
  }

  /* "YYYY-MM-DD HH:MM" (TZ wall clock) -> epoch ms, or null when blank/invalid. */
  function tzToEpoch(str) {
    if (!str) return null;
    var m = str.trim().match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
    if (!m) return null;
    var wall = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
    var guess = wall - tzOffsetAt(new Date(wall));
    return wall - tzOffsetAt(new Date(guess));
  }

  function apply() {
    var now = Date.now();
    document.querySelectorAll('[data-sl-dw]').forEach(function (el) {
      if (el.__slDwStart === undefined) {
        el.__slDwStart = tzToEpoch(el.getAttribute('data-sl-dw-start'));
        el.__slDwEnd = tzToEpoch(el.getAttribute('data-sl-dw-end'));
      }
      var live = (el.__slDwStart === null || now >= el.__slDwStart) &&
                 (el.__slDwEnd === null || now < el.__slDwEnd);
      el.style.display = live ? '' : 'none';
    });
  }

  apply();
  /* Flip badges at the window boundaries even if the page stays open. */
  setInterval(apply, 30000);
  /* Cover badges injected later (AJAX pagination / filters / quickview). */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; apply(); }, 100);
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', apply);
})();
